import { useState, useEffect } from 'react';
import { apiFetch } from './api.js';
import { useToast } from './ToastContext.jsx';

function adaptSystem(s) {
  return {
    id:           s.id,
    name:         s.name,
    description:  s.description,
    customerName: s.customer_name,
    bpartnerId:   s.bp_id ?? null,
  };
}

function adaptTimelineEntry(e) {
  return {
    id:              e.id,
    assetId:         e.asset_id,
    assetName:       e.asset_name,
    version:         e.version,
    status:          e.status,
    statusLabel:     e.status_label,
    updateType:      e.update_type,
    updateTypeLabel: e.update_type_label,
    plannedDate:     e.planned_date,
    appliedDate:     e.applied_date,
    description:     e.description,
  };
}

export function useSystems() {
  const { addToast } = useToast();
  const [systems, setSystems] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const controller = new AbortController();
    setLoading(true);
    apiFetch('/systems', { signal: controller.signal })
      .then(raw => {
        const list = Array.isArray(raw) ? raw : (raw.data ?? []);
        setSystems(list.map(adaptSystem));
      })
      .catch(err => { if (err.name !== 'AbortError' && err.status !== 403) addToast('Could not load your systems.'); })
      .finally(() => { if (!controller.signal.aborted) setLoading(false); });
    return () => controller.abort();
  }, [addToast]);

  return { systems, loading };
}

export function useSystemTimeline(systemId) {
  const { addToast } = useToast();
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!systemId) { setEntries([]); return; }
    const controller = new AbortController();
    setLoading(true);
    apiFetch(`/systems/${systemId}/timeline`, { signal: controller.signal })
      .then(raw => {
        const list = Array.isArray(raw) ? raw : (raw.data ?? []);
        setEntries(list.map(adaptTimelineEntry));
      })
      .catch(err => { if (err.name !== 'AbortError' && err.status !== 403) addToast('Could not load update history.'); })
      .finally(() => { if (!controller.signal.aborted) setLoading(false); });
    return () => controller.abort();
  }, [systemId, addToast]);

  return { entries, loading };
}
